<template>
  <div>
    <Player
      ref="Player"
      :subtitles="data"
      v-on:video="updateVideoState"
      :playAt="sentIdx"
      :url="mediaUrl"
      :slowAudioUrl="config.slowAudioUrl"
      :control="control" />

    <div ref="text"
      class="panel"
      v-bind:class="{
        'half-height': (mode !== 'default'),
        'phrase': (mode === 'phrases')
      }"
      v-on:scroll="handleScroll">
      <Sentences :texts="texts"
        :currentTime="video.currentTime"
        :lang="['en_us']"
        :slow="video.slow"
        :highlight="highlight"
        v-on:word="findDics"
        v-on:selectSentId="playSingle"
        v-if="mode !== 'dictionary'"></Sentences>

      <Sentences :texts="texts"
        :currentTime="video.currentTime"
        :slow="video.slow"
        v-on:word="findDics"
        :dict="true"
        v-else></Sentences>
    </div>

    <div ref="translate"
      class="panel half-height mt-2"
      v-if="mode === 'translate'">
      <Sentences :texts="texts"
        :lang="['zh_tw']"
        :slow="video.slow"
        :currentTime="video.currentTime"
        v-on:selectSentId="playSingle"></Sentences>
    </div>

    <div ref="dictionary"
      class="panel half-height mt-2"
      v-if="mode === 'dictionary'">
      <div class="p-3" v-if="dicData === null">已開啟字典功能，請點選想查詢的單字</div>
      <div class="p-3" v-else>
        <div>
          <span class="clickable dict-speak" @click="dictSpeak(dicData.key)">
            <i class="fa fa-volume-up"></i> {{ dicData.key }}
          </span>
          <!--
          <span class="float-right clickable" @click="isFavoriteVocab(dicData)" v-if="!$parent.isDemo">
            <img src="~@/assets/images/btn_book_mark_on.png" v-if="dicData.isMyDic" style="width: 0.9em;" />
            <img src="~@/assets/images/btn_book_mark_off.png" style="width: 0.9em;" v-else />
          </span>
          -->
        </div>

        <p class="pron">{{ dicData.phon }}</p>
        <p class="pre">{{ dicData.expl }}</p>

        <div v-for="(extend, extendIndex) in dicData.extend" :key="extendIndex"
          v-if="dicData.extend && dicData.extend.length > 0">
          <p>
            <span class="clickable dict-speak" @click="dictSpeak(extend.key)">
              <i class="fa fa-volume-up"></i> {{ extend.key }}
            </span>
          </p>
          <p class="pron">{{ extend.phon }}</p>
          <p class="pre">{{ extend.expl }}</p>
        </div>
      </div>
    </div>

    <div ref="vocabularies"
      class="panel half-height mt-2"
      v-if="mode === 'vocabularies'">
      <Vocabularies
        :data="vocabularies"
        v-on:sound="updateUrl"
        v-on:audio="playAudioFile" />
    </div>

    <div ref="phrases"
      class="panel half-height mt-2"
      v-if="mode === 'phrases'">
      <Phrases
        :data="phrases"
        v-on:sound="updateUrl"
        v-on:audio="playAudioFile" />
    </div>

    <div class="row mt-2">
      <div class="col-sm-6">
        <slot name="left"></slot>
      </div>

      <div class="col-sm-6 text-right">
        <button alt="翻譯"
          v-bind:class="{ 'btn': true, 'highlight': mode === 'translate' }"
          @click="switchMode('translate')">
          <!-- <i class="fa fa-language"></i> -->
          <img src="~../assets/images/btn_video_ch_off.png" v-if="mode !== 'translate'" />
          <img src="~../assets/images/btn_video_ch_on.png" v-else />
        </button>

        <button alt="字典"
          v-bind:class="{ 'btn': true, 'highlight': mode === 'dictionary' }"
          v-if="dictionary.length > 0 && texts && texts[0].dicInfos"
          @click="switchMode('dictionary')">
          <img src="~../assets/images/text_dictionary_off.png" v-if="mode !== 'dictionary'" />
          <img src="~../assets/images/text_dictionary_on.png" v-else />
        </button>

        <button alt="單字"
          v-bind:class="{ 'btn': true, 'highlight': mode === 'vocabularies' }"
          @click="switchMode('vocabularies')"
          v-if="vocabularies && vocabularies.length > 0">
          <img src="~../assets/images/text_word_off.png" v-if="mode !== 'vocabularies'" />
          <img src="~../assets/images/text_word_on.png" v-else />
        </button>

        <button alt="重點"
          v-bind:class="{ 'btn': true, 'highlight': mode === 'phrases' }"
          @click="switchMode('phrases')"
          v-if="phrases && phrases.length > 0">
          <img src="~../assets/images/text_key_off.png" v-if="mode !== 'phrases'" />
          <img src="~../assets/images/text_key_on.png" v-else />
        </button>

        <popper ref="downloadPopper"
          trigger="click"
          :options="{ placement: 'bottom' }"
          v-if="false">
          <div class="popper">
            <button class="btn"
              @click="$refs.downloadPopper.doClose() || exportSents()">
                課文
            </button>

            <button class="btn"
              @click="$refs.downloadPopper.doClose() || exportPhrase()"
              v-if="phrases && phrases.length > 0">
                片語
            </button>
          </div>

          <button slot="reference" class="btn">
            <img src="~../assets/images/text_download.png" />
          </button>
        </popper>
      </div>
    </div>
  </div>
</template>

<script>
  import Vocabularies from './Vocabularies.vue'
  import Phrases from './Phrases.vue'
  import Player from './modules/MiniPlayer.vue'
  import Sentences from './modules/Sentences.vue'
  import api from '../api.js'
  import dataOutput from './modules/dataOutput.js'
  import Popper from 'vue-popperjs'
  import 'vue-popperjs/dist/css/vue-popper.css'

  export default {

    name: 'Texts',

    props: {
      url: {
        type: String,
        required: false,
        default: ''
      },
      data: {
        type: Array,
        required: false,
        default: () => {
          return []
        }
      },
      dictionary: {
        type: Array,
        required: false,
        default: () => {
          return []
        }
      },
      vocabularies: {
        type: Array,
        required: false,
        default: () => {
          return []
        }
      },
      phrases: {
        type: Array,
        required: false,
        default: () => {
          return []
        }
      },
      config: {
        type: Object,
        required: false,
        default: () => {
          return {}
        }
      }
    },

    components: {
      Vocabularies,
      Phrases,
      Player,
      Sentences,
      Popper
    },

    data () {
      return {
        mode: 'default',
        texts: null,
        dicData: null,
        scrollPosition: 0,
        video: {},
        mediaUrl: '',
        control: '',
        sentIdx: -1,
        audio: null,
        fontSize: 's'
      }
    },

    computed: {
      highlight () {
        if (this.mode === 'vocabularies') {
          return this.vocabularies
        } else if (this.mode === 'phrases') {
          return this.phrases
        }

        return []
      }
    },

    created () {
      this.mediaUrl = this.url
      this.texts = this.data.slice(0)
      let self = this
      this.$watch('mode', (val, old) => {
        if (val === 'default' || val === 'translate') {
          self.mediaUrl = self.url
        }
      })

      this.$watch('video.currentTime', (val, old) => {
        self.handleTimeupdate()
      })
    },

    methods: {
      handleScroll (ewt) {
        return
        // if (this.$refs.translate) {
        //   this.$refs.translate.scrollTop = ewt.target.scrollTop
        // }

        // let currentScrollPosition = ewt.srcElement.scrollTop
        // this.scrollPosition = currentScrollPosition
      },

      handleTimeupdate () {
        let activeItem = (this.$refs.text && this.$refs.text.querySelector) ? this.$refs.text.querySelector('.active') : null
        let activeItem2 = (this.$refs.translate && this.$refs.translate.querySelector) ? this.$refs.translate.querySelector('.active') : null

        if (activeItem !== null &&
            ((activeItem.offsetTop + activeItem.offsetHeight) > (this.$refs.text.scrollTop + this.$refs.text.offsetHeight) ||
            activeItem.offsetTop < this.$refs.text.scrollTop)) {
          this.$refs.text.scrollTop = activeItem.offsetTop - 50
        }

        if (activeItem2 !== null &&
            ((activeItem2.offsetTop + activeItem2.offsetHeight) > (this.$refs.translate.scrollTop + this.$refs.translate.offsetHeight) ||
            activeItem2.offsetTop < this.$refs.translate.scrollTop)) {
          this.$refs.translate.scrollTop = activeItem2.offsetTop - 50
        }
      },

      findDics (word) {
        if (word === null) {
          return
        }
        let self = this
        api.Dictionary
          .Word(word)
          .then((res) => {
            let dicData = res.data.data
            dicData.extend = []
            self.dicData = dicData

            if (self.dicData.linkKeys && self.dicData.linkKeys.length > 0) {
              for (let idx in self.dicData.linkKeys) {
                api.Dictionary
                  .Word(self.dicData.linkKeys[idx])
                  .then((res) => {
                    self.dicData.extend.push(res.data.data)
                  })
              }
            }

            self.dictSpeak(self.dicData.key)
          })
      },

      switchMode (mode) {
        this.mode = (this.mode !== mode) ? mode : 'default'

        if (['translate', 'dictionary', 'vocabularies', 'phrases'].indexOf(this.mode) > -1) {
          if (this.video && this.video.state === 'playing') {
            this.$refs.Player.pause()
          }

          this.audio && this.audio.pause()
        }
      },

      updateVideoState (data) {
        this.video = data
      },

      updateUrl (data) {
        this.mediaUrl = data
      },

      playSingle (sentIdx) {
        if (this.mode === 'default' || this.mode === 'translate') {
          // this.sentIdx = sentIdx
          this.$refs.Player.repeatIdx = sentIdx
          this.$refs.Player.times = 1
          this.$refs.Player.jumpToSent(this.$refs.Player.subtitles[sentIdx])
          this.$refs.Player.play()
        }
      },

      playWord (word) {
        if (this.mode === 'dictionary') {
          word = word.trim()
          let except = ['?', '.', '!', ',', '"']

          if (word.length >= 1 && except.indexOf(word) === -1) {
            let path = 'https://livecloud.liveabc.com/CampusLearning/Lesson/' + this.config.lessonId + '/Dic/' + word.replace(/ /g, '+').replace(/'/, '%2527').toLowerCase() + '.mp3'
            this.control = 'pause'
            this.mediaUrl = path
            this.$nextTick(() => {
              this.control = 'play'
            })
          }
        }
      },

      playAudioFile (file) {
        if (this.video && this.video.state === 'playing') {
          this.$refs.Player.pause()
        }

        this.audio && this.audio.pause()
        this.audio = new window.Audio(file.url)
        this.audio.play()
      },

      dictSpeak (word) {
        api.Dictionary.Speak(word)
      },

      exportSents () {
        let dataContent = '** ' + this.$parent.lesson.courseType + '  Level : ' + this.$parent.lesson.level + '\r\n'
        dataContent += '   ' + this.$parent.lesson.name + '\r\n'
        dataContent += '   ' + this.$parent.lesson.name_i18N[0].value + '\r\n'
        let sentEn = ''
        let sentTw = ''
        // eslint-disable-next-line
        this.data.forEach(function (sent, index) {
          if (sent.isFirst) {
            dataContent += sentEn + sentTw + '\r\n'
            sentEn = ''
            sentTw = ''
          }

          if (sent.name !== '') {
            sentEn += '\r\n' + sent.name + ' : \r\n'
            sentTw += sent.name_i18N[0].value + ' : \r\n'
          }

          sentEn += '   ' + sent.text + '\r\n'
          sentTw += '   ' + sent.text_i18N[0].value + '\r\n'
        })

        dataContent += sentEn + sentTw + '\r\n'

        let filename = this.$parent.lesson.courseType + this.$parent.lesson.level + '-' + this.$parent.lesson.name + '-Lesson.txt'
        dataOutput(dataContent, filename)
      },

      exportPhrase () {
        let dataContent = '** ' + this.$parent.lesson.courseType + '  Level : ' + this.$parent.lesson.level + '\r\n'
        dataContent += '   ' + this.$parent.lesson.name + '\r\n'
        dataContent += '   ' + this.$parent.lesson.name_i18N[0].value + '\r\n\r\n'

        let re = new RegExp('<NO[0-9]+,', 'g')
        let re2 = new RegExp('\\n', 'g')
        this.phrases.forEach(function (data, index) {
          dataContent += ' ' + (index + 1) + '. ' + data.name + '\r\n'
          dataContent += '    ' + data.content_i18N[0].value.replace(re, '').replace(re2, '\r\n    ') + '\r\n\r\n'
        })

        let filename = this.$parent.lesson.courseType + this.$parent.lesson.level + '-' + this.$parent.lesson.name + '-Phrase.txt'
        dataOutput(dataContent, filename)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/style/app.scss";

  button {
    background-color: rgba(0, 0, 0, 0);
    border-color: rgba(0, 0, 0, 0);
    &:focus {
      box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.0)!important;
    }
  }

  .panel {
    height: 500px;
    border: 1px #ccc solid;
    overflow-y: scroll;
    position: relative;
  }

  .half-height {
    height: 240px;
  }

  .highlight, .highlight_p {
    color: red;
  }

  .clickable {
    cursor: pointer;

    &.dict-speak {
      color: #199513;
      font-size: 1.5em;
    }
  }

  .fa-volume-up {
    color: #000;
  }

  .highlight {
    color: $vocab-color;
  }

  .phrase {
    .highlight {
      color: $phrase-color!important;
    }
  }

  .pron {
    color: $pron-color;
  }
</style>



// WEBPACK FOOTER //
// Texts.vue?7d57fbc2